import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import type { DismissButtonProps } from "./DismissButtonProps";


export default /*@__PURE__*/_defineComponent({
  __name: 'DismissButton',
  props: {
    accentColor: {}
  },
  emits: ["dismiss"],
  setup(__props: any, { emit: __emit }) {

_useCssVars(_ctx => ({
  "4480d8b8": (_ctx.accentColor)
}))


const emit = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    type: "button",
    class: "-m-3 p-3 rounded-full",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('dismiss')))
  }, _cache[1] || (_cache[1] = [
    _createElementVNode("span", { class: "sr-only" }, "Dismiss", -1),
    _createElementVNode("svg", {
      class: "size-5 fill-current",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      stroke: "currentColor"
    }, [
      _createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M6 18L18 6M6 6l12 12"
      })
    ], -1)
  ])))
}
}

})